import getMonitoringActivities from './monitoringActivities/getMonitoringActivities'
import getMonitoringTasks from './monitoringTasks/getMonitoringTasks'

// Delete-guard for manual monitoring sites: a site with monitoring activities or tasks
// attached must not be deletable. Shared by SamplePlanningPanel (and replaces the old
// hasTasksForSite helper). Both lookups use size:1 — we only need existence, not the rows.
// Both bypass the query cache: a stale empty answer would let a site with data be deleted.
export const getMonitoringSiteAssociations = async ({
  monitoringSiteId,
  farmId,
}: {
  monitoringSiteId: string
  farmId: string
}): Promise<{ hasActivities: boolean; hasTasks: boolean }> => {
  const [activities, tasks] = await Promise.all([
    getMonitoringActivities({ query: { monitoringSiteId, size: 1, farmId } }),
    getMonitoringTasks({ query: { monitoringSiteId, size: 1 } }),
  ])

  return {
    hasActivities: activities.items.length > 0,
    hasTasks: tasks.items.length > 0,
  }
}
